import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page/Page';
import {  SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, Results, AddRole } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const Masterlanguages = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [isadd, setIsadd] = useState(false);
  const [roleobj, setRoleobj] = useState({});
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);
  async function fetchmodules()
{
    let masterroles_arr = await sendNetworkRequest('/admin/getlanguages', {}, {},false)
   setOrders(masterroles_arr.module)
}
 
  function dismiss()
  {
    setRoleobj({})
    setIsadd(false)
  }
  function addrole()
  {
    setIsadd(true)
  }
  function editrole(roleobj)
  {
    setRoleobj(roleobj)
    setIsadd(true)
  }
  async function updaterolestatus(roleobj, status)
  {
    // snackbarCtx.setSnack({
    //   ...snackbarCtx,
    //   open: true,
    //   type: "success",
    //   msg: "Status Change Successfully" ,
    //   vertical: "top",
    // });
    let bodycontent = {}
    bodycontent['status'] = status;

    if(roleobj)
    {
      bodycontent['id'] = roleobj.id;
      bodycontent['name'] = roleobj.name;

     
    }
    let masterroles_arr = await sendNetworkRequest('/admin/addlanguage', {}, bodycontent,false)
    
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: masterroles_arr.status,
      msg: masterroles_arr.message,
      vertical: "top",
    });
    fetchmodules()
  }

  async function updatelanguagestatus(roleobj, status)
  {
    let bodycontent = {}
    bodycontent['status'] = status;

    if(roleobj)
    {
      bodycontent['id'] = roleobj.id;
      bodycontent['name'] = roleobj.name;

     
    }
    let masterroles_arr = await sendNetworkRequest('/admin/languagestatusupdate', {}, bodycontent,false)
    
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: masterroles_arr.status,
      msg: masterroles_arr.message,
      vertical: "top",
    });
    fetchmodules()
  }
  async function updaterole(rolename,roleobj)
  {
    let bodycontent = {}
    bodycontent['name'] = rolename?.name;
    bodycontent['priority'] = rolename?.priority;
    if(roleobj && roleobj.id){    
      bodycontent['id'] = roleobj.id;
      bodycontent['status']  = roleobj.status;
      bodycontent['priority'] = roleobj?.priority;
    
    }
      let masterroles_arr = await sendNetworkRequest('/admin/addlanguage', {}, bodycontent,false)
      snackbarCtx.setSnack({
        ...snackbarCtx,
        open: true,
        type: masterroles_arr.status,
        msg: masterroles_arr.message,
        vertical: "top",
      });
    
    
    if(masterroles_arr && masterroles_arr.status === 'success')
    {
      setIsadd(false)
      setRoleobj({})
  
      fetchmodules()
    }
   
  }
  useEffect(() => {
   fetchmodules()
  }, []);

  return (
    <Page
      className={classes.root}
      title="Manage Language"
    >
      <Header onAdd={addrole}/>
      {isadd ? <AddRole onUpdate={updaterole}   onDismiss={dismiss} roleObj={roleobj}/> : null }
      <Results
        onEdit={editrole}
        onStatusupdate ={updatelanguagestatus}
        onUpdatestattus={updaterolestatus}
        onupdatestatus={editrole}
        className={classes.results}
        orders={orders} //
      />
    </Page>
  );
});

export default Masterlanguages;
